export const locale = {
  'ORDERS': {
    'ONMAP': {
      'TITLE' : 'Заказы на карте',
    },
  },
};
